<template>
  <div class="card-body py-3" :class="{ 'highlight-background': isResearchHighlighted }">
    <h3 v-if="isLoaded" class="mb-0 t-500">
      <router-link :to="{ name: 'research_group.explore', params: { category: 'research_topics' }}" class="t-primary text-decoration-none">
        {{ $options.filters.capitalize(getModuleName(researchGroup, 'topic', 0)) }}
      </router-link>
      <span class="t-secondary ml-1">{{ researchTopics.length }}</span>
      <editable v-if="isLoaded && $can.edit('research_group', researchGroup.rw_access) && !isEmpty(researchTopics)" @create="handleCreate()"></editable>
      <router-link v-if="isLoaded && (isEmpty(researchTopics) || !$can.edit('research_group', researchGroup.rw_access))" :to="{ name: 'research_group.explore', params: { category: 'research_topics' }}" class="link-button t-xs pull-right t-400">
        view all
      </router-link>
    </h3>

    <!-- content and loaded -->
    <template v-if="isLoaded">
      <!-- no mission and cannot edit -->
      <p v-if="!$can.edit('research_group', researchGroup.rw_access) && isEmpty(researchTopics)" class="mb-0 mt-1 t-sm t-secondary">
        No {{ getModuleName(researchGroup, 'topic', 0) }} listed, yet
      </p>

      <!-- nothing to show -->
      <p v-if="isEmpty(researchTopics) && $can.edit('research_group', researchGroup.rw_access)" class="mb-0 mt-3 text-center">
        <i class="fa fa-plus d-block t-secondary"></i>
        <a href="#" @click.prevent="handleCreate()" class="t-sm">Add {{ getModuleName(researchGroup, 'topic', 1) }}</a>
      </p>

      <!-- show research topics -->
      <ul v-if="!isEmpty(researchTopics)" class="list-unstyled mb-0 mt-2">
        <li class="position-relative" v-for="(research, index) in researchTopics" :key="research.id">
          <p class="mb-0 mt-1 clearfix mr-4" v-line-clamp="1">
            <i class="fa fa-file-text t-sm" :class="{ 't-secondary pr-1': research.matches > 0, 't-secondary pr-2': !research.matches}"></i>
            <span v-if="research.matches > 0" class="t-xs t-yellow px-1 py-1 mr-2 bg-grey bd-radius t-uppercase">match</span>
            <router-link replace :to="{ name: 'research_group.show', query: { research_topic: research.slug_values[0], hr: research.slug_text }}" v-html="research.title"></router-link>
          </p>

          <i v-if="$can.edit('research_group', researchGroup.rw_access)" @mousedown.prevent="handleEdit(research, index)" class="fa fa-pencil ml-2 t-blue is-edit-pencil is-edit-pencil--right h-100"></i>
        </li>
      </ul>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import Editable from '@/components/shared/Editable'

export default {
  name: 'researchGroupResearch',
  components: {
    Spinner,
    Editable
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    researchTopics () {
      return this.isLoaded ? this.researchGroup.research_topics || [] : []
    }
  },
  data () {
    return {
      isResearchHighlighted: false
    }
  },
  mounted () {
    if (this.isLoaded && this.$route.query.h === 'research_topics') this.isResearchHighlighted = true
  },
  watch: {
    isLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        if (this.$route.query.h === 'research_topics') this.isResearchHighlighted = true
      }
    }
  },
  methods: {
    handleCreate () {
      this.$events.$emit('modal:research_topic:create:open', this.researchGroup, {})
    },
    handleEdit (value, index) {
      this.$events.$emit('modal:research_topic:create:open', this.researchGroup, value)
    }
  }
}
</script>
